module.exports = __webpack_public_path__ + "static/media/block-3.38d70178.png";